import { useState, useEffect } from 'react'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import MosSmartDialog from '../common/MosSmartDialog'
import createDialogTitle from '../../../generic/utilities/dialogUtil'
import { apiPost } from '../../../generic/Api_Functions'
import AlertUI from '../../../generic/AlertUI'
import { Stack, TextField, Box, CircularProgress } from '@mui/material'
import useMosInfo from '../common/provider/useMosInfo'

const AddPartsDialog = ({ open, onCancel, onSuccess, fabricationOrder, jobReference }) => {
  const { t_ } = useSmartTranslation()
  const { device, worker } = useMosInfo()
  const [AlertElement, showAlert, dismiss] = AlertUI()
  const [quantity, setQuantity] = useState('')
  const [loading, setLoading] = useState(false)

  // Reset the form and clear any stale (non-auto-dismissing) error alert each time the dialog opens.
  useEffect(() => {
    if (open) {
      setQuantity('')
      setLoading(false)
      dismiss()
    }
  }, [open, dismiss])

  const accept = async () => {
    if (!(Number(quantity) > 0)) {
      showAlert({ severity: 'warning', title: t_('Quantity must be greater than 0') })
      return
    }
    setLoading(true)
    try {
      await apiPost('mos/parts/add/' + worker.id + '/' + device.id + '/' + fabricationOrder.id + '/' + jobReference.id, { quantity: Number(quantity) })
      if (onSuccess) onSuccess()
      onCancel()
    } catch (error) {
      showAlert({ severity: 'error', title: t_(error.message) })
    } finally {
      setLoading(false)
    }
  }

  return (
    <MosSmartDialog
      title={createDialogTitle({ color: 'primary', title: t_('Add parts') })}
      setOpen={open}
      cancelCallback={onCancel}
      acceptCallback={accept}
      disableButtons={loading}
    >
      {AlertElement}
      <Stack spacing={2} sx={{ mt: 1, p: 2 }}>
        <TextField
          fullWidth
          type='number'
          value={quantity}
          label={t_('Quantity to add')}
          onChange={(e) => setQuantity(e.target.value)}
          size='small'
          sx={{ mt: 1 }}
          inputProps={{ min: 1 }}
        />
        <Box sx={{ display: 'flex', justifyContent: 'center', pt: 1, visibility: loading ? 'visible' : 'hidden' }}>
          <CircularProgress size={24} />
        </Box>
      </Stack>
    </MosSmartDialog>
  )
}

export default AddPartsDialog
